// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-submit[data-v-0f06743d] {\n  color: white;\n  width: 90px;\n  height: 40px;\n  background-color: #00a5ff;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 0px 2px 4px rgba(44, 56, 82, 0.1);\n}\n.button-submit[data-v-0f06743d]:hover {\n  background-color: #0195e4 !important;\n}\n.button-submit b[data-v-0f06743d] {\n  color: #fff;\n}\n.bs-btn[data-v-0f06743d] {\n  font-size: 0.75em !important;\n}", ""]);
// Exports
module.exports = exports;
